import styles from "./styles.module.scss";
import Modal from "@mui/material/Modal/Modal";
import Button from "@mui/material/Button/Button";
import closeIconModal from "./../../../../assets/_CloseIconModal_.svg";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { IApiResponse } from "../../../../@types/api-response.type";
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';
import { IProjectPlannedHistory, IProjectPlannedHistoryPage } from "../../../../@types/project/project-implemented.type";
import { getProjectPlannedHistory } from "../../../../services/api/ProjectPlanned/ProjectPlannedService";


interface HistoryPlannedModalProps {
  openModal: boolean,
  handleCloseModal: () => void,
  projectId: string,
  id: string,
}

export const HistoryPlannedModal: React.FC<HistoryPlannedModalProps> = ({openModal, handleCloseModal, projectId}) => { 
  const [history, setHistory] = useState<IProjectPlannedHistoryPage>();

  const loadDomainData = async () => {
    try {
      const response = (await getProjectPlannedHistory(projectId, 0, 10))  as IApiResponse<IProjectPlannedHistoryPage>;
      setHistory(response.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadDomainData();
  }, []);

  function GetTimeline(items: IProjectPlannedHistory[]){
    let component = [];
    for (let index = 0; index < items?.length; index++) {
      const element = items[index];
      component.push(<>
        <TimelineItem>
          <TimelineOppositeContent color="text.secondary">
            {dayjs(element.createdAt).format("YYYY-MM-DD HH:mm:ss")}
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>{element.action}</TimelineContent>
        </TimelineItem>
      </>)
      
    }
    return component;
  }
  
  return (
    <Modal open={openModal} onClose={handleCloseModal}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3>Historico de Alteração</h3>
          <Button onClick={handleCloseModal} className={styles.iconButton}>
            {closeIconModal && <img src={closeIconModal} />}
          </Button>
        </div>
        <div className={styles.container}>
          <Timeline
            sx={{
              [`& .${timelineOppositeContentClasses.root}`]: {
                flex: 0.2,
              },
            }}
          >
            {history && GetTimeline(history.items)}
          </Timeline>
        </div>
      </div>
    </Modal>
  );
};
